import { render, staticRenderFns } from "./return_money.vue?vue&type=template&id=31080432&scoped=true&"
import script from "./return_money.vue?vue&type=script&lang=js&"
export * from "./return_money.vue?vue&type=script&lang=js&"
import style0 from "./return_money.vue?vue&type=style&index=0&id=31080432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31080432",
  null
  
)

export default component.exports